export default {
    "savedQueries": {
        "savedQueries": "Saved Queries",
        "saveCurrentQuery": "Save Current Query",
        "manageSavedQueries": "Manage Saved Queries",
        "savedQueryAlreadyExists": "A saved query with that name already exists. Would you like to replace it?",
        "noSavedQuery": "You have not yet saved a search query...",
        "delete": "Delete this saved query"
    },

    "recentQueries": {
        "noRecentQuery": "You have not yet searched for something...",
        "delete": "Delete this recent query",
        "save": "Save this query"
    },

    "recentDocuments": {
        "recentDocuments": "Recent documents",
        "noRecentDocument": "You have not yet opened a document...",
        "delete": "Delete this recent document"
    },

    "editSavedQuery": {
        "title": "Saved Query",
        "name": "Name"
    },

    "exportQuery": {
        "dialogTitle": "Export",
        "dialogOutputFormat": "Output format",
        "dialogMaxCount": "Max rows",
        "dialogSourceType": "Export from",
        "dialogResult": "Current result",
        "dialogSelection": "Current selection",
        "btnTitle": "Export results",
        "exportResult": "Export result as {type}",
        "exportSelection": "Export selection as {type}",
        "btnDownload": "Download",
        "btnClose": "Close",
        "successNotification": "Download complete",
        "exportedColumns": "Columns to export",
        "exportedColumnsLabelTooltip": "Select the columns that you want to export, an empty selection means exporting all columns",
        "dialogMaxCountTooltip": "By default, the number of results is limited to {count}"
    },

    "manageSavedQueries": {
        "title": "Manage Saved Queries",
        "save": "Save",
        "reorder": "Reorder",
        "remove": "Remove",
        "removeAll": "Remove all",
        "export": "Export",
        "name": "Name",
        "rss": "RSS Feed"
    },

};
